import { FC, useState } from 'react'
import { Button, PopUp } from '@ketch-com/deck'
import { Divider, TextField, Typography } from '@mui/material'

type Props = {
  note: string
  onSubmit: (note: string) => void
  onClose: () => void
}

export const NoteModal: FC<Props> = ({ note, onSubmit, onClose }) => {
  const [newNote, setNewNote] = useState(note)

  return (
    <PopUp
      isOpen
      onClose={onClose}
      variant="dialog"
      title="Note"
      popUpActionChildren={
        <>
          <Button color="secondary" size="large" onClick={onClose}>
            Close
          </Button>
          <Button
            color="primary"
            size="large"
            disabled={!newNote || newNote === note}
            onClick={() => onSubmit(newNote)}
          >
            Save
          </Button>
        </>
      }
    >
      <Divider />
      <TextField
        value={newNote}
        multiline
        minRows={3}
        sx={{ minWidth: { xs: '100%', sm: '500px' } }}
        onChange={e => setNewNote(e.target.value)}
      />
      <Typography variant="body" color="darkDuskFaded.main">
        Only you will be able to edit or delete this note
      </Typography>
      <Divider />
    </PopUp>
  )
}
